import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { GroupRascunho } from 'src/app/models/group';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { GroupService } from 'src/app/services/group/group.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';

@Component({
    selector: 'ngbd-modal-content',
    template: `
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title text-center">
                Você não tem produtos tradicionais aderidos!
            </h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <p class="clean-modal-subtitle text-center" style="font-size: 1.375rem; color: #555;">Para criar um grupo Flex você deve aderir no mínimo <b>1</b> produtos tradicionais</p>
    </div>
    <div class="clean-modal-footer col-12 mb-4">
        <button  class="custom-filter-button button-color-just" type="button" (click)="goContracts();">Fazer adesão</button>
    </div>
    `
  })
  export class NgbdModalContent {
    constructor(private router: Router,public activeModal: NgbActiveModal) {}
    goContracts(){
        this.activeModal.dismiss();
        this.router.navigate(['portal/novobeneficio/contratar']);
    }
  }

@Component({
  selector: 'app-grupo-create',
  templateUrl: './grupo-create.component.html',
  styleUrls: ['./grupo-create.component.css']
})
export class GrupoCreateComponent implements OnInit {

    public currentUser: Auth;
    public form: FormGroup;
    public isFormValid = true;
    public rascunho: GroupRascunho;
    public step: number;
    isEmpty: boolean;

    constructor(private router: Router, private groupService: GroupService, private contractService: ContratoService,
                private authenticationService: AuthenticationService, private formBuilder: FormBuilder,
                private alertService: NewAlertService, private modalService: NgbModal,) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.rascunho = this.groupService.getRascunho();

        if(this.rascunho)
        this.step = 3;
        else
        this.step = 1

        let name = '';
        let description = '';

        if (this.rascunho) {
        name = this.rascunho.name;
        description = this.rascunho.description;
        }

        this.form = this.formBuilder.group({
        name: [name, Validators.required],
        description: [description]
        });

        this.loadBenefits();
    }

    loadBenefits() {
        this.contractService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                const contain = [CategoriaProduto.Tradicional];
                let beneficios = response.result;
                beneficios = beneficios.filter(item => contain.includes(item.categoriaProduto))
                if (beneficios.length <= 0 || beneficios.length < 1) {
                    this.isEmpty = true;
                    this.open();
                }
            } else {
                this.alertService.error(response.message);
            }
        },
        error => {
            this.alertService.error('Erro ao carregar os produtos da cedente' + error);
        });
    }

    open() {
        this.modalService.open(NgbdModalContent, {centered: true, backdrop : 'static', size: 'lg'});
    }

    next() {
        this.isFormValid = true;
        if (this.form.valid) {
        if (!this.rascunho) {
            this.rascunho = new GroupRascunho(this.form.controls.name.value, this.form.controls.description.value);
        } else {
            this.rascunho.name = this.form.controls.name.value;
            this.rascunho.description = this.form.controls.description.value;
        }
        this.groupService.setRascunho(this.rascunho);
        this.router.navigate(['portal/grupos/beneficios']);
        } else {
        this.isFormValid = false;
        }
    }
}
